import type { FieldProp } from 'react-typed-form';

import * as React from 'react';
import { css, html } from 'react-strict-dom';

import { Text } from '../components';

type Choice = Readonly<{
  value: unknown;
  label: string;
}>;

type Props = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldProp<any>;
  choices: ReadonlyArray<Choice>;
}>;

export default function FieldSelect({ field, choices }: Props) {
  const currentChoice = choices.find((c) => c.value === field.value);

  return (
    <html.div>
      <Text as="label" style={styles.label}>
        {field.label}
      </Text>
      <html.select
        style={styles.select}
        value={currentChoice ? currentChoice.label : undefined}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          const label = e.target.value;
          const choice = choices.find((c) => c.label === label);
          if (choice) field.handleValueChange(choice.value);
        }}
      >
        <html.option />
        {choices.map((choice) => (
          <html.option key={choice.label} value={choice.label}>
            {choice.label}
          </html.option>
        ))}
      </html.select>
    </html.div>
  );
}

const styles = css.create({
  label: {
    display: 'block',
    marginBottom: 3,
    paddingLeft: 9,
  },
  select: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 640,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd',
    borderRadius: 3,
    paddingBlock: 8,
    paddingInline: 12,
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    lineHeight: 1.5,
    color: '#333',
    backgroundColor: '#fff',
  },
});
